import {
  IconButton,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  useTheme
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import SecondaryButton from "@components/buttons/SecondaryButton"
import PrimaryButton from "@components/buttons/PrimaryButton"
import { useState } from "react";

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  title?: string,
  showClose?: boolean,
  primaryButtonAction: () => Promise<void> | void;
  primaryButtonText?: string;
  primaryButtonDisabled?: boolean;
  secondaryButtonAction?: () => void;
  secondaryButtonText?: string;
  fullWidth?: boolean;
  testId?: string;
  children?: React.ReactNode;
}

const Dialog = ({
  open,
  onClose,
  title,
  showClose = true,
  primaryButtonAction,
  primaryButtonText = "Save",
  primaryButtonDisabled,
  secondaryButtonAction = onClose,
  secondaryButtonText = "Cancel",
  fullWidth = true,
  testId,
  children
}: DialogProps) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const performPrimaryAction = async () => {
    setLoading(true)
    await primaryButtonAction();
    setLoading(false)
  }

  return <>
    <MuiDialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth='md'
      slotProps={{
        backdrop: { invisible: true },
        paper: { style: { borderRadius: 8, width: '783px' } }
      }}
      data-testid={testId}
    >
      {
        showClose
          ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon sx={{ fontSize: 32, color: theme.palette.grey[600] }} />
            </IconButton>
          )
          : null
      }


      {title &&
        <MuiDialogTitle sx={{
          padding: 3
        }}>
          {title}
        </MuiDialogTitle>
      }

      <MuiDialogContent
        sx={{
          paddingTop: '40px',
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingbottom: '36px',
        }}
      >
        {children}
      </MuiDialogContent>

      <MuiDialogActions
        sx={{
          paddingTop: 1,
          paddingBottom: 3,
          paddingRight: 3,
          paddingLeft: 3,
        }}
      >
        <SecondaryButton
          action={secondaryButtonAction}
        >
          {secondaryButtonText}
        </SecondaryButton>

        <PrimaryButton
          action={performPrimaryAction}
          disabled={loading || primaryButtonDisabled}
          type='submit'
        >
          {primaryButtonText}
        </PrimaryButton>
      </MuiDialogActions>
    </MuiDialog>
  </>
}

export default Dialog